module.exports = __webpack_public_path__ + "img/guibai.76eb33b6.gif";